import { render } from "./EditAlertConfiguration.vue?vue&type=template&id=72032bf3"
import script from "./EditAlertConfiguration.vue?vue&type=script&lang=js"
export * from "./EditAlertConfiguration.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__